import { useTickerPrices } from '../../hooks/useTickerPrices';

function fmt(n) {
  if (n == null) return '—';
  return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function fmtChg(n) {
  if (n == null) return null;
  const sign = n >= 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}%`;
}

export default function Ticker() {
  const { tickers, quotes, loading } = useTickerPrices();

  // Nothing to render yet (first load, cache warming)
  if (!tickers.length) return <div className="ticker" />;

  // Duplicate for seamless CSS scroll animation
  const all = [...tickers, ...tickers];

  return (
    <div className="ticker">
      <div className="ticker-track">
        {all.map((sym, i) => {
          const q = quotes[sym];
          const up = (q?.change_pct ?? 0) >= 0;
          const chgStr = fmtChg(q?.change_pct);
          return (
            <span key={`${sym}-${i}`} className="tick">
              <span className="tick-sym">{sym}</span>
              {!loading && q?.price != null && (
                <span className="tick-px">${fmt(q.price)}</span>
              )}
              {!loading && chgStr && (
                <span className={up ? 'tick-up' : 'tick-dn'}>
                  {up ? '▲' : '▼'} {chgStr}
                </span>
              )}
              {i < all.length - 1 && <span className="tick-sep">·</span>}
            </span>
          );
        })}
      </div>
    </div>
  );
}
